<template>
  <div class="Moregister"
       id="Moregister">
    <div class="Moregister_head">
      <router-link :to="{name:'MoPersonal'}">
        <i class="iconfont icon-fanhui"></i>
      </router-link>
    </div>
    <div class="Moregister_cont">
      <div class="cont_tit">
        <p class="cont_tit_p">手机号注册</p>
        <i class="line"></i>
      </div>
      <el-form size="small"
               :model="form"
               :rules="formRules"
               ref="RgsiterForm"
               class="main_form">
        <div class="regCont_div">
          <i class="iconfont icon-shouji"></i>
          <el-form-item prop="ReCell">
            <el-input placeholder="请输入手机号"
                      v-model="form.ReCell"></el-input>
          </el-form-item>
        </div>
        <div class="regCont_div">
          <i class="iconfont icon-mima"></i>
          <el-form-item prop="RePassword">
            <el-input placeholder="请输入密码"
                      type="password"
                      v-model="form.RePassword"></el-input>
          </el-form-item>
        </div>
        <div class="regCont_div">
          <i class="iconfont icon-mima"></i>
          <el-form-item prop="ReAginPassword">
            <el-input placeholder="再次输入密码"
                      type="password"
                      v-model="form.ReAginPassword"></el-input>
          </el-form-item>
        </div>
        <div class="regCont_div verCode">
          <el-input placeholder="请输入验证码"
                    @keyup.enter.native="RegisterUser"
                    oninput="if(value.length>4)value=value.slice(0,4)"
                    v-model="form.ReVerCode"></el-input>
          <el-button class="sendCode"
                     style="padding:0px;"
                     v-if="isShowGetCode"
                     @click="ActiCode()">获取验证码</el-button>
          <el-button class="sendCode"
                     style="padding:0px;"
                     v-else>{{countdown}}后可重试</el-button>
        </div>
        <div class="regCont_div regibtn"
             @click="registerlogin()">
          注册
        </div>
        <router-link :to="{name:'Mologin',query:{rediect:'home'}}">
          <p class="alerdybtn">已有账号，去登录</p>
        </router-link>
        <div class="regi_checkout">
          <el-checkbox v-model="form.Rechecked">阅读并同意</el-checkbox>
          <span>《全科知家服务协议》</span>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import validate from '../../assets/unit/validate';
export default {
  inject: ['reload'],
  data () {
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (!validate.validateMobile(value)) {
        callback(new Error("手机号需为11位数字"));
      } else {
        callback();
      }
    };
    const VALIDATE_PASSWORD = (rule, value, callback) => {
      if (!validate.validatePassword(value)) {
        callback(new Error('密码必须包含字母和数字且密码长度为6-20个字符'));
      } else {
        callback();
      }
    };
    return {
      // 注册发送验证码
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      callbackurl: '',
      form: {
        ReCell: '',
        RePassword: '',
        ReAginPassword: '',
        ReVerCode: '',
        Rechecked: true,
      },
      formRules: {
        ReCell: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: VALIDATE_MOBILE_NO, trigger: 'blur' }
        ],
        RePassword: [
          { validator: VALIDATE_PASSWORD, trigger: 'blur' },
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        ReAginPassword: [
          { validator: VALIDATE_PASSWORD, trigger: 'blur' },
          { required: true, message: "请确认密码", trigger: "blur" }
        ],
        ReVerCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      userType: 0
    }
  },
  methods: {
    // 验证码数字变化
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 获取验证码
    ActiCode () {
      if (this.form.ReCell == '') {
        this.$msgmodal({
          title: '系统提示',
          content: '手机号不能为空!',
          type: 'warn',
        });
      } else {
        this.httphelper.post('/api/VerifCodeApi/NoteVerifCode',
          {
            type: 1,
            phoneNumber: this.form.ReCell
          }).then((res) => {
            if (res.data.code == 200) {
              this.$msgmodal({
                content: '发送成功!',
                type: 'success',
              });
              this.isShowGetCode = false
              this.countDown()
            } else if (res.data.code == 231) {
              this.$msgmodal({
                title: '系统提示',
                content: '手机号已存在，请直接登录!',
                type: 'warn',
              });
              clearInterval(this.timer)
            } else if (res.data.code == 233) {
              this.$msgmodal({
                title: '系统提示',
                content: '发送失败!',
                type: 'warn',
              });
              clearInterval(this.timer)
            }
          })
      }
    },
    // 注册
    registerlogin () {

      this.$refs.RgsiterForm.validate(valid => {
        if (valid) {
          if (this.form.RePassword != this.form.ReAginPassword) {
            this.$msgmodal({
              title: '系统提示',
              content: '两次密码不同，请确认密码!',
              type: 'warn',
            });
          } else if (this.form.ReVerCode == '') {
            this.$msgmodal({
              title: '系统提示',
              content: '请输入验证码!',
              type: 'warn',
            });
          } else if (this.form.Rechecked == false) {
            this.$msgmodal({
              title: '系统提示',
              content: '请勾选协议!',
              type: 'warn',
            });
          } else {
            this.httphelper.post('/api/LoginApi/GetUserRegister',
              {
                sourceType: 1,
                phoneNumber: this.form.ReCell,
                pwd: this.form.RePassword,
                vcode: this.form.ReVerCode
              }).then((res) => {
                if (res.data.code == 234) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '验证码失效!',
                    type: 'warn',
                  });
                } else if (res.data.code == 205) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '验证码错误!',
                    type: 'warn',
                  });
                } else {
                  this.$message({
                    message: '注册成功',
                    type: 'success'
                  });
                  this.reload()
                  localStorage.setItem('nickname', res.data.data.nickname)
                  this.ResData = JSON.stringify(res.data.data)
                  localStorage.setItem('ResData', this.ResData)
                  var aData = new Date();
                  var CurrentDategetTime = 0
                  var VipEdDategetTime = 0
                  if (res.data.data.memberDate.m_EndDate) {
                    var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                    var VipEdDate = res.data.data.memberDate.m_EndDate;

                    CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                    VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                  }
                  if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                    this.userType = 0;
                  } else {
                    if (res.data.data.memberDate.m_Type == 1) {
                      this.userType = 1;
                    } else if (res.data.data.memberDate.m_Type == 2) {
                      this.userType = 2;
                    } else {
                      this.userType = 0;
                    }
                  }
                  localStorage.setItem('userType', this.userType);
                  this.$cookies.set('token_chinagp', res.data.data.token);
                  let redirectUrl = '';
                  if (this.callbackurl != '') {
                    redirectUrl = decodeURIComponent(this.callbackurl);
                    window.location.href = redirectUrl
                  }
                }
              })
          }
        }
      })
    },
  },
  components: {
  },
  created () {
    /** 获取callback地址 */
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
      this.callbackurl = encodeURIComponent(this.$route.query.callback);
    }
  },
}
</script>
<style   scoped>
.Moregister_head {
    padding-left: 10px;
    text-align: center;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    background: #fff;
    height: 40px;
    z-index: 99;
    line-height: 60px;
}
.Moregister_head >>> a {
    position: absolute;
    left: 30px;
}
.Moregister_cont {
    width: 100%;
    position: relative;
    top: 38px;
}

.cont_tit {
    width: 90px;
    margin-left: 30px;
    margin-top: 50px;
}
.cont_tit >>> .line {
    width: 30px;
    height: 4px;
    background: #0082fe;
    border-radius: 2px;
    display: inherit;
    margin: 0 auto;
    margin-top: 10px;
}

.cont_tit_p {
    color: #157eff;
    font-size: 18px;
}

.main_form {
    width: 80%;
    height: auto;
    margin: 0 auto;
    margin-top: 45px;
}
.regCont_div {
    width: 100%;
    height: 42px;
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 27px;
    line-height: 42px;
    position: relative;
}
.regCont_div >>> i {
    color: #878787;
    font-size: 21px;
    margin-left: 17px;
}
.regCont_div >>> .el-form-item {
    position: absolute;
    top: 0;
    width: 84%;
    height: 100%;
    margin-left: 40px;
}
.regCont_div >>> .el-input__inner {
    border: none;
    height: 42px;
    line-height: 42px;
    color: #878787;
    font-size: 15px;
}

.verCode {
    width: 100%;
    border: none;
}
.verCode >>> .el-input {
    width: 60%;
    float: left;
    border-bottom: 1px solid #ebebeb;
}

.sendCode {
    width: 34%;
    height: 40px;
    background: #e9f5ff;
    border: 1px solid #157eff;
    float: left;
    color: #157eff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    margin-left: 15px;
    cursor: pointer;
}
.regibtn {
    width: 100%;
    margin: 0 auto;
    height: 34px;
    background: #157eff;
    box-shadow: 0px 1px 10px 0px rgba(21, 126, 255, 0.5);
    border-radius: 17px;
    margin-top: 49px;
    text-align: center;
    line-height: 34px;
    color: #ffffff;
    font-size: 16px;
}

.alerdybtn {
    text-align: center;
    color: #157eff;
    font-size: 15px;
    margin-top: 19px;
}
.regi_checkout {
    width: 100%;
    margin-top: 40px;
    text-align: center;
}
.regi_checkout >>> span {
    color: #157eff;
    font-size: 14px;
    cursor: pointer;
}
</style>
 